import { BreakpointObserver } from '@angular/cdk/layout';
import {
  EventEmitter,
  Injectable,
  computed,
  inject,
  signal,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { Camera } from '@models';
import { filter, map } from 'rxjs';
import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../../../tailwind.config';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  breakpointObserver = inject(BreakpointObserver);
  private router = inject(Router);

  constructor() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentView.set(event.urlAfterRedirects.slice(1).split('?')[0]);
      });
  }

  fastForward = new EventEmitter();
  fastBackward = new EventEmitter();
  pauseVideo = new EventEmitter();
  replayVideo = new EventEmitter();

  showConsole = signal(false);
  debugMode = signal(false);
  demoMode = signal(false);
  showOverlays = signal(true);
  showUI = signal(true);
  showSimXpert = signal(false);
  showChat = signal(false);

  appState = signal<'success' | 'canceled' | 'noCamera'>('success');
  fullScreen = signal(false);
  showSideBar = signal(false);
  cameraId = signal('');
  showSceneLauncher = signal(false);
  trackingMode = signal(false);
  sampleMovie = signal<string>(null);
  theme = resolveConfig(tailwindConfig);
  currentView = signal('');
  cameras: Camera[] = [];

  isPortraitMode = toSignal(
    this.breakpointObserver
      .observe(['(orientation: portrait)', '(orientation: landscape)'])
      .pipe(map((result) => result.breakpoints['(orientation: portrait)'])),
  );

  cameraConfig = computed(() => ({
    deviceId: this.cameraId() ? { exact: this.cameraId() } : undefined,
    frameRate: { ideal: 30 },
    width: { ideal: 1280 },
    height: { ideal: 720 },
  }));

  switchCamera() {
    let cameraIndex;
    const currentCameraIndex = this.cameras.findIndex(
      (camera) => camera.id === this.cameraId(),
    );
    if (currentCameraIndex !== -1) {
      cameraIndex = currentCameraIndex;
    }
    cameraIndex = (cameraIndex + 1) % this.cameras.length;
    this.cameraId.set(this.cameras[cameraIndex].id);
  }
}
